module.exports = __webpack_public_path__ + "media/icons/minus-icon-blue-4200ad73.svg";